export { default } from 'Components/Modal/components/Feedback/Feedback'
